import api from './api';

export const getCurrentPDF = async () => {
  const response = await api.get('/pdf/current');
  return response.data;
};

export const getPresignedUploadUrl = async (filename) => {
  const response = await api.post('/pdf/presigned-upload', {
    filename,
    content_type: 'application/pdf'
  });
  return response.data;
};

export const confirmPDFUpload = async (filename, fileSize) => {
  const response = await api.post('/pdf/confirm-upload', {
    filename,
    file_size: fileSize
  });
  return response.data;
};

export const deletePDF = async () => {
  const response = await api.delete('/pdf/current');
  return response.data;
};

export const uploadPDFToS3 = async (presignedData, file) => {
  const formData = new FormData();

  // Add all presigned fields first
  Object.keys(presignedData.upload_fields).forEach(key => {
    formData.append(key, presignedData.upload_fields[key]);
  });

  // Add the file last
  formData.append('file', file);

  // Upload directly to S3
  const response = await fetch(presignedData.upload_url, {
    method: 'POST',
    body: formData
  });

  if (!response.ok) {
    throw new Error(`S3 upload failed: ${response.statusText}`);
  }

  return response;
};
